import { api } from './client';
import type {
  ProductListResponse,
  ProductDetailResponse,
  ProductUpdateResponse,
  ProductDeleteResponse,
  ProductFields,
  BulkDeleteParams,
  BulkDeleteResponse,
  ReEvaluateResponse,
} from './types';

export function getProducts(params: { page: number; limit?: number; search?: string }) {
  const qs = new URLSearchParams({ page: String(params.page) });
  if (params.limit) qs.set('limit', String(params.limit));
  if (params.search) qs.set('search', params.search);
  return api.get<ProductListResponse>(`/api/admin/products?${qs}`);
}

export function exportProducts() {
  return api.raw('/api/admin/products/export');
}

export function getProduct(barcode: string) {
  return api.get<ProductDetailResponse>(`/api/admin/products/${encodeURIComponent(barcode)}`);
}

export function updateProduct(barcode: string, fields: ProductFields) {
  return api.put<ProductUpdateResponse>(
    `/api/admin/products/${encodeURIComponent(barcode)}`,
    fields,
  );
}

export function reEvaluateProduct(barcode: string) {
  return api.post<ReEvaluateResponse>(
    `/api/admin/products/${encodeURIComponent(barcode)}/re-evaluate`,
  );
}

export function deleteProduct(barcode: string) {
  return api.del<ProductDeleteResponse>(
    `/api/admin/products/${encodeURIComponent(barcode)}`,
  );
}

export function bulkDeleteProducts(params: BulkDeleteParams) {
  return api.del<BulkDeleteResponse>('/api/admin/products/bulk', params);
}
